import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CardHeaderConfig, MenuAction} from '@shared/model';
import {NavigationService} from '@shared/service';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent {
  @Input() config!: CardHeaderConfig;
  @Input() extraText = '';
  @Output() onActionClick = new EventEmitter<MenuAction>();

  constructor(public navigationService: NavigationService) {
  }

  navigate(): void {
    if (this.config.titleLink != null) {
      this.navigationService.navigate(this.config.titleLink);
    }
  }
}
